/* 
 * @author Tommy Brière
 * @copyright (c) 2017 Groupe PVP
 * @fileoverview TODO
 */
(function($g) {
    "use strict";
    var VIDEO_URL = "/video/blank.m4v";
    var Signal = $g.Signal;
    
    //var tri = $g.try;
    var LOG_TO_CONSOLE = false;
    var TIMEOUT = 20 * 1000;
    var SEEK_TIMEOUT = 1000;
    var INIT_TIMEOUT = 2 * 1000;
    var RETRY_ERROR = 20 * 1000;
    
    function time() {
        return new Date().getTime();
    }

    function VideoPlayer(video) {
        /**
         * Certains navigateurs ne se comportent pas correctement
         * Lorsque on change l'état du vidéo associé en succession rapide
         * On va donc garder l'état supposé du vidéo
         * Pour ajuster le vidéo
         * 
         */
        var SEEKING = {
            name: "SEEKING",
            seeked: function() {
                setEtat(PAUSED);
                update();
            },
            timeout: function() {//If timeout, just make as if it succeeded
                setEtat(PAUSED);
                update();                
            }
        };
        var PAUSED = {
            name: "PAUSED",
            play: function() {
                callPlay();
                setEtat(LOADING);
                regTimeout(TIMEOUT);
                update();
            }, seek: function() {
                seekTo();
                setEtat(SEEKING);
                regTimeout(SEEK_TIMEOUT);
                update();
            },
            changed: changeSrc
        };
        var PLAYING = {
            name: "PLAYING",
            pause: function() {
                video.pause();
                setEtat(PAUSED);
                update();
            },
            seek: function() {
                video.pause();
                setEtat(PAUSED);
                update();
            },
            changed: changeSrc
        };
        var LOADING = {
            name: "LOADING",
            timeout: function() {
                $g.warning("timeout sur play " + video.src); 
                setEtat(ERROR);
            }, 
            time: function() {
                setEtat(PLAYING);
                update();
            },
            error: function() {
                $g.warning("Impossible de lire " + video.src); 
                setEtat(ERROR);
            }            
        };
        var ERROR = {
            name: "ERROR",
            changed: changeSrc,
            current: function() {
                if (time() > etatTime + RETRY_ERROR ) {
                    video.src = "";
                }
            },
            time: function() {
                setEtat(PLAYING);
                update();                
            }
        };
        var IDLE = {
            name: "IDLE",
            changed: changeSrc
        };
        var CLICKED = {
            name: "CLICKED",
            time: function() {
                setEtat(IDLE);
                update();
            },
            error: function() {
                setEtat(ERROR);
                update();                
            }            
        };
        var REQUIRE_CLICK = {
            name: "REQUIRE_CLICK",
            time: function() {
                setEtat(IDLE);
                update();
            },
            click: function() {
                setEtat(CLICKED);
                callPlay();                
            },
            muted: function() {
                setEtat(IDLE);
            }
        };
        var TESTING = {
            timeout: function() {
                //may require click
                setEtat(REQUIRE_CLICK);
                me.onInitComplete.trigger();
            }, 
            time: function() {
                setEtat(IDLE);
                me.onInitComplete.trigger();
                update();
            },
            error: function() {
                //got erreor checking if we can autoplay
                //try to autoplay, may work
                setEtat(REQUIRE_CLICK);
                me.onInitComplete.trigger();
                update();                
            }
        };
        var UNDEF;
        var MISSING_FUNC = {};
        
        var me = this;
        var current;
        var next;
        var playing;
        var currentTime;
        var etatTime = time();
        
        var etat;
        var timeout;
        var video;   
        var muted = false;
        
        function seekTo() {
            if (UNDEF !== currentTime) {
                video.currentTime = currentTime;
                //$g.log("seek to", currentTime);
                currentTime = UNDEF;
            }            
        }
        
        function changeSrc(targetSrc) {
            video.src = targetSrc;
            updateMuted();
            if (video.src===current) {
                seekTo();
            }
            callPlay();
            setEtat(LOADING);
            regTimeout(TIMEOUT);
        }             
        
        function regTimeout(time) {
            clearTimeout(timeout);
            timeout=setTimeout(function() {
                event("timeout");
            }, time);            
        }
                
        function videoEnded() {
            event("ended");
        }
        
        function videoError(e) {
            $g.warning("impossible de jouer le video " + video.src); 
            var r = event("error");
            if (r===MISSING_FUNC) {
                $g.warning("Erreur non géré", e);
                setEtat(ERROR);
            }
        }
        
        function videoTime() {
            //$g.log(e);
            event("time");
        }
        
        function videoPlay() {//Android browser fire this event if video did not play
            //event("time");
            //event("playing");
        }
        
        function videoSeeked() {
            if (LOG_TO_CONSOLE) {
                $g.log("seeked");
            }
            event("seeked");
        }
        
        function attachEvents() {
            video.addEventListener("timeupdate", videoTime);
            video.addEventListener("play", videoPlay);
            video.addEventListener("ended", videoEnded);
            video.addEventListener("error", videoError);
            video.addEventListener("seeked", videoSeeked);
        }
        
        function removeEvents() {
            video.removeEventListener("timeupdate", videoTime);
            video.removeEventListener("play", videoPlay);
            video.removeEventListener("ended", videoEnded);
            video.removeEventListener("error", videoError);    
            video.removeEventListener("seeked", videoSeeked);
        }
        
        function setEtat(newEtat) {
            //event("exit");
            lastEvent = null;
            etat = newEtat;
            etatTime = time();
            //event("enter");
        }
        
        var lastEvent = null;
        function event(evt, data) {    
            var r = MISSING_FUNC;
            var f = etat ? etat[evt] : null;
            if (evt != lastEvent) {
                if (LOG_TO_CONSOLE) {
                    $g.log(etat, evt, data);
                }
                lastEvent = evt;
            }
            if (f) {
                r = f(data);
            }
            return r;
        }
        
        function callPlay() {
            var p = video.play();
            if (p && p.then) {
                p.then(function() {//make sure we get events
                    event("time");
                    event("playing");
                }, function(e) {
                    $g.log(e);
                    if (e==="NotSupportedError") {
                        videoError(e);
                    }
                });//Catch play rejected error
            }
        }
        
        function update() {
            var targetSrc = current || next;
            var shouldPlay = current && playing;
            var srcChanged = targetSrc && video.src != targetSrc;
            updateMuted();
            if (srcChanged) {
                event("changed", targetSrc);
            } else {
                if (current && currentTime!==UNDEF) {
                    event("seek");
                } else if (shouldPlay) {
                    event("play");
                } else {
                    event("pause");
                }  
            }                
        }
        
        function updateMuted() {
            const value = muted || current !== video.src;
            if (video.muted !== value) {
                video.muted = value;
                var $video = $(video);
                $video.attr({muted: value});
            }
        }
        
        /**
         * play the current music
         * @returns {undefined}
         */
        this.play = function() {
            playing=true;
            update();
        };
        
        /**
         * Sto playing the current music
         * @returns {undefined}
         */
        this.stop = function() {
            playing=false;
            update();
        };
                
        Object.defineProperty(this, "playing", {
            get: function() {
                return playing;
            },
            set: function(value) {
                playing = value;
                update();
            }
        });
        Object.defineProperty(this, "current", {
            get: function() {
                return current;
            },
            set: function(value) {
                if (value != current) {
                    current = value;
                    currentTime = UNDEF;
                    event("current", value);
                    update();
                }
            }
        });
        Object.defineProperty(this, "next", {
            get: function() {
                return next;
            },
            set: function(value) {
                next = value;
                update();
            }
        });        
        Object.defineProperty(this, "currentTime", {
            get: function() {
                if (me.ready) {
                    if (currentTime!==UNDEF) {
                        return currentTime;
                    }
                    return video.currentTime * 1000;
                } else {
                    return -1;                    
                }
            },
            set: function(value) {
                currentTime = value / 1000;
                update();
            }
        });     
        Object.defineProperty(this, "ready", {
            get: function() {
                if (video.src === current) {
                    return (etat === PLAYING || etat === PAUSED);
                }
            }
        });
        Object.defineProperty(this, "error", {
            get: function() {
                return (etat==ERROR);
            }            
        });
        Object.defineProperty(this, "muted", {
            get: function() {
                return muted;
            },
            set: function(value) {
                if (value !== muted) {
                    muted = value;
                    updateMuted();

                    if (value) {
                        event("muted");
                    }
                }
            }
        });
              
        this.init = function(complete) {
            if (complete) {
                me.onInitComplete.once(complete);
            }
            if (video) {
                etat = IDLE;  
                me.onInitComplete.trigger();
            } else {
                etat = TESTING;
                video = document.createElement("Video");
                var $video = $(video);
                $video.attr({
                    autobuffer: true,
                    playsinline: true,
                    muted: false,
                    hwz:"off",
                    "webkit-playsinline": true
                }); 
                video.muted = false;                  
                video.src = VIDEO_URL;
                callPlay();                
                regTimeout(INIT_TIMEOUT);                
            }
            me.video = video;
            attachEvents();            
        };
        
        /**
         * Click start video
         * @returns {undefined}
         */
        this.clicked = function() {
            event("click");
        };
        
        /**
         * Check if we have
         * @returns {undefined}
         */
        this.requireClick = function() {
            return (etat == REQUIRE_CLICK);
        };
        
        this.destroy = function() {
            if (video) {
                removeEvents();
                video.pause();                
                video=null;
            }
            clearTimeout(timeout);
            timeout=null;
        };        
                
        this.onInitComplete = new Signal();
    }
    
    $g.VideoPlayer = VideoPlayer;
    
})(PVPGEngine);